import { restClient } from 'config/store/configureStore';
import { INTERVENTIONS_API_URL } from 'constants/InterventionConstants';
import { TECHNICIAN } from 'constants/ModeConstants';

export default {
  getPaymentHistory: id => restClient.get(`${INTERVENTIONS_API_URL[TECHNICIAN]}/${id}/paymentHistory`),
};
